<div class="row justify-content-center">
  <div class="col-md-8 col-lg-8 col-12">
    <h3>{{ "accounts.account_statement.title" | translate }}</h3>
    <div class="row">
      <div class="col-12 justify-content-center">
        <div *ngIf="this.activationDate.toDate() <= this.maxDate">
          <h5>{{ "accounts.account_statement.select" | translate }}</h5>
          <div class="container">
            <br>
            <p-calendar [(ngModel)]="date" [showIcon]="true" [maxDate]="maxDate" [minDate]="minDate" view="month"
              (onSelect)="getAvailableStatements($event)" dateFormat="yy-mm" [readonlyInput]="true"
              inputId="monthpicker"></p-calendar>
          </div>
        </div>
        <div *ngIf="this.activationDate.toDate() > this.maxDate" class="col-12">
          <div class="alert alert-info text-center" role="alert">
            <i class="fas fa-info-circle fa-2x"></i>
            <p class="m-0">{{ "accounts.account_statement.not_available" | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
